import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FooterComponent } from '../../../Common/footer/footer.component';
import { HeaderComponent } from '../../../Common/header/header.component';
import { BannerEnquiryFormComponent } from '../../banner-enquiry-form/banner-enquiry-form.component';

@Component({
    selector: 'app-term-and-condition',
    templateUrl: './term-and-condition.component.html',
    styleUrls: ['./term-and-condition.component.scss'],
    standalone: true,
    imports: [HeaderComponent,FooterComponent,ReactiveFormsModule, CommonModule]

})
export class TermAndConditionComponent {

}
